import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["to", "className", "ariaLabel", "label"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _isEmpty from 'lodash/isEmpty';
import { getValidProps } from '../../modules/foundation/services/props';
export function arePathsEqual(path1, path2) {
  function cleanPathName() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return path.replace(/^\/|\/$/g, '');
  }
  return cleanPathName(path1) === cleanPathName(path2);
}
export function getInternalLinkProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    to = _ref.to,
    className = _ref.className,
    ariaLabel = _ref.ariaLabel,
    label = _ref.label,
    rest = _objectWithoutProperties(_ref, _excluded);
  var validProps = ['id', 'ref', 'activeClassName', 'activeStyle', 'onClick', 'partiallyActive', 'replace', 'state', 'role', 'aria-label', 'aria-labelledby', 'aria-selected', 'aria-expanded', 'aria-checked', 'aria-busy', 'style'];
  var validRestProps = getValidProps(rest, validProps);
  var options = _objectSpread({
    to: to,
    activeClassName: 'active',
    activeStyle: {
      textDecoration: 'underline',
      textUnderlinePosition: 'under'
    }
  }, validRestProps);
  if (!_isEmpty(className)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      className: className
    });
  }
  var finalAriaLabel = ariaLabel || label || '';
  if (!_isEmpty(finalAriaLabel)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      'aria-label': finalAriaLabel
    });
  }
  return options;
}